import { c as _c } from "react/compiler-runtime";
import { Request } from '../../../../../../../typings/Request.interface';
import { APISource } from '../../../../../../../typings/Source.interface';
import { numberWithCommas } from '../../../../utils';
import { getRejectionCauseBreakdown } from '../../../../utils/rejection-causes';
import Badge from '../../../common/base/Badge';
import Divider from '../../../common/base/Divider';
import Chip from '../../../common/base/Chip';
import Text from '../../../common/base/Text';
import CopyableText from '../../../common/CopyableText';
import DisplayDate from '../../../common/DisplayDate';
import { Div } from '../../../common/helpers/StyledUtils';
import { MetadataGrid } from '../../../common/MetadataGrid';
export const RequestMetadata: React.FC<{
  request: Request;
  source: APISource;
  embedded: boolean;
}> = t0 => {
  const $ = _c(100);
  const {
    request,
    source,
    embedded
  } = t0;
  let t1;
  if ($[0] !== request || $[1] !== source) {
    t1 = request?.rejection_cause && source && getRejectionCauseBreakdown(request.rejection_cause)({
      request,
      source
    });
    $[0] = request;
    $[1] = source;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rejection_cause_breakdown = t1;
  const t2 = embedded ? 1 : 2;
  const t3 = embedded ? 0 : 3;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      columns: t2,
      gap: t3
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== embedded) {
    t5 = embedded ? 0 : {
      x: 6,
      b: 8
    };
    $[6] = embedded;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text muted={true} ellipsis={true}>Status</Text>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = !rejection_cause_breakdown;
  const t8 = !!rejection_cause_breakdown;
  const t9 = rejection_cause_breakdown ? "Rejected" : "Accepted";
  let t10;
  if ($[9] !== t7 || $[10] !== t8 || $[11] !== t9) {
    t10 = <Badge success={t7} danger={t8} subtle={true}>{t9}</Badge>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== embedded || $[14] !== t10) {
    t11 = <MetadataGrid embedded={embedded}>{t6}{t10}</MetadataGrid>;
    $[13] = embedded;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== embedded) {
    t12 = embedded && <Divider />;
    $[16] = embedded;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== embedded || $[19] !== rejection_cause_breakdown) {
    t13 = rejection_cause_breakdown && <><MetadataGrid embedded={embedded}><Text muted={true} ellipsis={true}>Rejection Cause</Text><Badge danger={true} subtle={true}>{rejection_cause_breakdown.label}</Badge></MetadataGrid>{embedded && <Divider />}</>;
    $[18] = embedded;
    $[19] = rejection_cause_breakdown;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Text muted={true} ellipsis={true}>Source</Text>;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = source && `/sources/${source.id}`;
  const t16 = source?.name || "";
  let t17;
  if ($[22] !== t15 || $[23] !== t16) {
    t17 = <Chip outline={true} mono={true} to={t15} label={t16} />;
    $[22] = t15;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== embedded || $[26] !== t17) {
    t18 = <MetadataGrid embedded={embedded}>{t14}{t17}</MetadataGrid>;
    $[25] = embedded;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== embedded) {
    t19 = embedded && <Divider />;
    $[28] = embedded;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Text muted={true} ellipsis={true}>Request ID</Text>;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== request.id) {
    t21 = <CopyableText value={request.id} mono={true} />;
    $[31] = request.id;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== embedded || $[34] !== t21) {
    t22 = <MetadataGrid embedded={embedded}>{t20}{t21}</MetadataGrid>;
    $[33] = embedded;
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== embedded) {
    t23 = embedded && <Divider />;
    $[36] = embedded;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Text muted={true} ellipsis={true}>Ingested at</Text>;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== request.ingested_at) {
    t25 = <DisplayDate date={request.ingested_at} />;
    $[39] = request.ingested_at;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== embedded || $[42] !== t25) {
    t26 = <MetadataGrid embedded={embedded}>{t24}{t25}</MetadataGrid>;
    $[41] = embedded;
    $[42] = t25;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== embedded) {
    t27 = embedded && <Divider />;
    $[44] = embedded;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  let t28;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Text muted={true} ellipsis={true}>Processed at</Text>;
    $[46] = t28;
  } else {
    t28 = $[46];
  }
  let t29;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      justify: "space-between",
      align: "center",
      gap: 2
    };
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== request.created_at) {
    t30 = <DisplayDate date={request.created_at} />;
    $[48] = request.created_at;
    $[49] = t30;
  } else {
    t30 = $[49];
  }
  let t31;
  if ($[50] !== request.created_at) {
    t31 = new Date(request.created_at).getTime();
    $[50] = request.created_at;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] !== request.ingested_at) {
    t32 = new Date(request.ingested_at).getTime();
    $[52] = request.ingested_at;
    $[53] = t32;
  } else {
    t32 = $[53];
  }
  const t33 = t31 - t32;
  let t34;
  if ($[54] !== t33) {
    t34 = numberWithCommas(t33);
    $[54] = t33;
    $[55] = t34;
  } else {
    t34 = $[55];
  }
  let t35;
  if ($[56] !== t34) {
    t35 = <Text as="span" text_wrap={false} size="s" semi={true} muted={true}>{t34}ms</Text>;
    $[56] = t34;
    $[57] = t35;
  } else {
    t35 = $[57];
  }
  let t36;
  if ($[58] !== t30 || $[59] !== t35) {
    t36 = <Div flex={t29}>{t30}{t35}</Div>;
    $[58] = t30;
    $[59] = t35;
    $[60] = t36;
  } else {
    t36 = $[60];
  }
  let t37;
  if ($[61] !== embedded || $[62] !== t36) {
    t37 = <MetadataGrid embedded={embedded}>{t28}{t36}</MetadataGrid>;
    $[61] = embedded;
    $[62] = t36;
    $[63] = t37;
  } else {
    t37 = $[63];
  }
  let t38;
  if ($[64] !== embedded) {
    t38 = embedded && <Divider />;
    $[64] = embedded;
    $[65] = t38;
  } else {
    t38 = $[65];
  }
  let t39;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <Text muted={true} ellipsis={true}>Created events</Text>;
    $[66] = t39;
  } else {
    t39 = $[66];
  }
  let t40;
  if ($[67] !== request.events_count) {
    t40 = <Badge icon="success" neutral={true}>{request.events_count}</Badge>;
    $[67] = request.events_count;
    $[68] = t40;
  } else {
    t40 = $[68];
  }
  let t41;
  if ($[69] !== embedded || $[70] !== t40) {
    t41 = <MetadataGrid embedded={embedded}>{t39}{t40}</MetadataGrid>;
    $[69] = embedded;
    $[70] = t40;
    $[71] = t41;
  } else {
    t41 = $[71];
  }
  let t42;
  if ($[72] !== embedded) {
    t42 = embedded && <Divider />;
    $[72] = embedded;
    $[73] = t42;
  } else {
    t42 = $[73];
  }
  let t43;
  if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <Text muted={true} ellipsis={true}>Ignored events</Text>;
    $[74] = t43;
  } else {
    t43 = $[74];
  }
  let t44;
  if ($[75] !== request.ignored_count) {
    t44 = <Badge icon="block" neutral={true}>{request.ignored_count}</Badge>;
    $[75] = request.ignored_count;
    $[76] = t44;
  } else {
    t44 = $[76];
  }
  let t45;
  if ($[77] !== embedded || $[78] !== t44) {
    t45 = <MetadataGrid embedded={embedded}>{t43}{t44}</MetadataGrid>;
    $[77] = embedded;
    $[78] = t44;
    $[79] = t45;
  } else {
    t45 = $[79];
  }
  let t46;
  if ($[80] !== embedded) {
    t46 = embedded && <Divider />;
    $[80] = embedded;
    $[81] = t46;
  } else {
    t46 = $[81];
  }
  let t47;
  if ($[82] !== t11 || $[83] !== t12 || $[84] !== t13 || $[85] !== t18 || $[86] !== t19 || $[87] !== t22 || $[88] !== t23 || $[89] !== t26 || $[90] !== t27 || $[91] !== t37 || $[92] !== t38 || $[93] !== t4 || $[94] !== t41 || $[95] !== t42 || $[96] !== t45 || $[97] !== t46 || $[98] !== t5) {
    t47 = <Div grid={t4} p={t5}>{t11}{t12}{t13}{t18}{t19}{t22}{t23}{t26}{t27}{t37}{t38}{t41}{t42}{t45}{t46}</Div>;
    $[82] = t11;
    $[83] = t12;
    $[84] = t13;
    $[85] = t18;
    $[86] = t19;
    $[87] = t22;
    $[88] = t23;
    $[89] = t26;
    $[90] = t27;
    $[91] = t37;
    $[92] = t38;
    $[93] = t4;
    $[94] = t41;
    $[95] = t42;
    $[96] = t45;
    $[97] = t46;
    $[98] = t5;
    $[99] = t47;
  } else {
    t47 = $[99];
  }
  return t47;
};
export default RequestMetadata;